import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "infos"
};
const _hoisted_3 = {
  class: "flex-line"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "游戏名：", -1);
const _hoisted_5 = {
  class: "flex-line"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "包名：", -1);
const _hoisted_7 = {
  class: "flex-line"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "游戏版本：", -1);
const _hoisted_9 = {
  style: {
    "color": "#faad14"
  }
};
const _hoisted_10 = {
  class: "flex-line"
};
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "包体大小：", -1);
export default /*#__PURE__*/_defineComponent({
  __name: 'packageInfoTemplate',
  props: {
    packageInfo: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const pack_info_box = {
      display: 'flex',
      'align-items': 'center',
      padding: '10px',
      'background-color': '#ECECEC',
      'border-radius': '4px'
    };
    const icon_img = {
      flex: '0 0 auto',
      width: '60px',
      height: '60px',
      'margin-right': '10px',
      'border-radius': '4px'
    };
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_row, {
        class: "marginB10"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          offset: 4,
          span: 20
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            style: pack_info_box
          }, [_createElementVNode("img", {
            style: icon_img,
            src: __props.packageInfo.icon,
            alt: ""
          }, null, 8, _hoisted_1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", null, _toDisplayString(__props.packageInfo.gameTitle), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(__props.packageInfo.packageName), 1)])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, "V" + _toDisplayString(__props.packageInfo.verName), 1), _createElementVNode("span", _hoisted_9, "（Code：" + _toDisplayString(__props.packageInfo.verCode) + "）", 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", null, _toDisplayString((__props.packageInfo.fileSize / 1024 / 1024).toFixed(4)) + "M", 1)])])])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});